import './modernizr'
import 'bootstrap';

/*
    ***** JQUERY *****
 */


/* TODO bs-breakpoints */

/*!
 * bsBreakpoints v1.1.1 (https://github.com/Johann-S/bs-breakpoints)
 * Copyright 2018 - 2019 Johann-S <johann.servoire@gmail.com>
 * Licensed under MIT (https://github.com/Johann-S/bs-breakpoints/blob/master/LICENSE)
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = global || self, global.bsBreakpoints = factory());
  }(this, function () { 'use strict';
  
    (function () {
      // Add polyfill for Custom Events
      function CustomEvent(ev, params) {
        var evt = document.createEvent('CustomEvent');
        params = params || {
          bubbles: false,
          cancelable: false,
          detail: undefined
        };
        evt.initCustomEvent(ev, params.bubbles, params.cancelable, params.detail);
        return evt;
      }
  
      if (typeof window.CustomEvent !== 'function') {
        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
      }
    })();
  
    var breakPoints = {
      xs: {
        min: 0,
        max: 575
      },
      sm: {
        min: 576,
        max: 767
      },
      md: {
        min: 768,
        max: 991
      },
      lg: {
        min: 992,
        max: 1199
      },
      xl: {
        min: 1200,
        max: 1399
      },
      xxl: {
        min: 1400,
        max: Infinity
      }
    };
  
    var breakPointsDetected = false;
    var currentBreakpoint = null;
    var Events = {
      INIT: 'init.bs.breakpoint',
      NEW: 'new.bs.breakpoint'
    };
  
    var getJQuery = function getJQuery() {
      return window.jQuery;
    };
  
    var getBreakPoints = function getBreakPoints() {
      var minsm = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-sm'), 10);
      var minmd = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-md'), 10);
      var minlg = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-lg'), 10);
      var minxl = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-xl'), 10);
      var minxxl = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-xxl'), 10);
  
      breakPoints.xs.max = minsm - 1; // update xs
  
      breakPoints.sm.min = minsm;
      breakPoints.sm.max = minmd - 1; // update md
  
      breakPoints.md.min = minmd;
      breakPoints.md.max = minlg - 1; // update lg
  
      breakPoints.lg.min = minlg;
      breakPoints.lg.max = minxl - 1; // update xl
  
      breakPoints.xl.min = minxl;
      breakPoints.xl.max = minxxl - 1; // update xxl
  
      breakPoints.xxl.min = minxxl;
      breakPointsDetected = true;
    };
  
    var _detectBreakPoint = function _detectBreakPoint() {
      var widthWindow = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  
      for (var key in breakPoints) {
        if (widthWindow <= breakPoints[key].max && widthWindow >= breakPoints[key].min) {
          return key;
        }
      }
  
      return currentBreakpoint;
    };
  
    var dispatchBreakpoint = function dispatchBreakpoint(breakPointKey, eventName) {
      if (eventName === void 0) {
        eventName = Events.NEW;
      }
  
      if (!currentBreakpoint || currentBreakpoint !== breakPointKey) {
        currentBreakpoint = breakPointKey;
        var $ = getJQuery();
  
        if ($) {
          var $event = $.Event(eventName, {
            breakpoint: breakPointKey
          });
          $(window).trigger($event);
        } else {
          var event = new window.CustomEvent(eventName, {
            detail: breakPointKey
          });
          window.dispatchEvent(event);
        }
      }
    };
  
    var bsBreakpoints = {
      init: function init() {
        getBreakPoints();
        dispatchBreakpoint(_detectBreakPoint(), Events.INIT);
        window.addEventListener('resize', function () {
          dispatchBreakpoint(_detectBreakPoint());
        });
      },
      detectBreakpoint: function detectBreakpoint() {
        if (!breakPointsDetected) {
          getBreakPoints();
        }
  
        currentBreakpoint = _detectBreakPoint();
        return currentBreakpoint;
      },
      getCurrentBreakpoint: function getCurrentBreakpoint() {
        return currentBreakpoint;
      }
    };
  
    return bsBreakpoints;
  
  }));
  
/* end bs-breakpoints */

/* begin animate css add and remove class */

const dropDownIn = (element, animation = 'slideInLeft', prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    /* console.log(animation); */
    const animationName = `${prefix}${animation}`;
    const node = element;
    node.prev().addClass('opening');
    node.addClass(`${prefix}animated`).addClass(animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.css('transform', 'translateX(0)');
      node.removeClass(`${prefix}animated`).removeClass(animationName);
      node.prev().removeClass('opening').addClass('opened');
      resolve('Animation ended');
    }

    node[0].addEventListener('animationend', handleAnimationEnd, {once: true});
  });


  const dropDownOut = (element, animation = 'slideOutLeft', prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    /* console.log(animation); */
    const animationName = `${prefix}${animation}`;
    const node = element;
    node.prev().addClass('closing');
    node.addClass(`${prefix}animated`).addClass(animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.css('transform', 'translateX(-100%)');
      node.removeClass(`${prefix}animated`).removeClass(animationName);
      node.prev().removeClass('opened').removeClass('closing');
      resolve('Animation ended');
    }

    node[0].addEventListener('animationend', handleAnimationEnd, {once: true});
  });
/* end animate css add and remove class */



(function($) {

    /* menu desktop init */
    let menuCollapsed = $('.navbar > .navbar-collapse > .main-navbar > .main-navbar__item > .main-navbar-item__link > .menu-inner-desktop');
    let navLink = $('#navbarToggler > div > ul > li > .nav-link');
    let innerLink = $('.menu-inner-desktop > .menu-desktop-wrapper > .menu-desktop-links > li > a');

    /* menu mobile init */
    let hamburger = $('#hamburger-menu-mobile');
    let menuMobileContainer = $('.navbar-collapse > div');
    let firstLevelMobile = $('.navbar-collapse > div > .main-navbar');
    let menuLink = $('.navbar-collapse > div > .main-navbar > .main-navbar__item > .main-navbar__item__link');
    let language = $('.language-link');
    let closeMenuMobile = $('.close-mobile-menu-icon');
    let languageSelect = $('.language-select');
    let menuLinkArrow = $('.navbar-collapse > div > .main-navbar > .main-navbar__item > .menu-link-arrow');

  
    /* menu desktop function revisited */
    function menuDesktop() {

      navLink.on('click', function(e) {
        if($(this).next().length > 0) {
          e.preventDefault();
          menuDesktopHeight();
          $('.menu-desktop-links__item__link.opened').closest('.menu-desktop-links__item').find('.menu-desktop-current-page__next-lvl__go-back').trigger('click');
          
          if($(this).hasClass('opened') || $(this).hasClass('openings')) {
            /* console.log('opened'); */
            dropDownOut($(this).next());
            $('body').css('overflow', '');
          } else {
            $(navLink).each(function(index){
              if($(this).hasClass('opened') || $(this).hasClass('openings')) {
                dropDownOut($(this).next());
              }
            });
            
            /* console.log('not opened'); */
            dropDownIn($(this).next());
            $('body').css('overflow', 'hidden');
          }
        }
      });


      /* click outside function */
      jQuery.fn.clickOutside = function(callback){
        var $me = this;
        $(document).on('mouseup', function(e) {
            if ( !$me.is(e.target) && $me.has(e.target).length === 0 ) {
                callback.apply($me);
            }
        });
      };

      /* close the menu when i click outside */
      $('nav').clickOutside(function(){
          let navLink = $('#navbarToggler > div > ul > li > .nav-link.opened');
          navLink.trigger('click');
          $('body').css('overflow', 'unset');
      });

      $('.language-select__top').clickOutside(function(){
        if($('.language-select__top').hasClass('active')) {
          $('.language-select__top').trigger('click');
        }
      });


      $('.language-select__top').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('#select-language').toggleClass('rotate-arrow-base');
        $('#language-list').slideToggle(500);
      });
  

      /* click on submenu link */
      innerLink.on('click', function(e) {
          if ($(this).next().length) {
              e.preventDefault();
              dropDownIn($(this).next());
          }
      });

      /* go back button click */
      $('.menu-inner-desktop > div > .menu-desktop-current-page').on('click', '.menu-desktop-current-page__next-lvl__go-back', function(e){
        e.preventDefault();
        dropDownOut($(this).closest('.menu-inner-desktop'));
      });

    }

    /* menu mobile function */
    function menuMobile() {

      var svg_next = '\
        <svg width="12" height="25" viewBox="0 0 12 25" fill="none" xmlns="http://www.w3.org/2000/svg">\
          <g filter="url(#filter0_i_903_5806)">\
              <path d="M1.49884 24L10.0165 13.1163C10.2998 12.7543 10.2998 12.2457 10.0165 11.8837L1.49884 1" />\
          </g>\
          <defs>\
              <filter id="filter0_i_903_5806" x="0.317383" y="0.0761719" width="11.4116" height="25.8477" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>\
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>\
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\
                  <feOffset dy="1"/>\
                  <feGaussianBlur stdDeviation="0.5"/>\
                  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>\
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>\
                  <feBlend mode="normal" in2="shape" result="effect1_innerShadow_903_5806"/>\
              </filter>\
          </defs>\
        </svg>';

        $('.menu-desktop-current-page.menu-current-page-mobile').each(function(index){
          var svg_back = '\
          <svg width="22" height="31" viewBox="0 0 22 31" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="go-back-arrow-main-menu">\
            <g filter="url(#filter0_i_957_5366_fl_' + $(this).data('uid') + ')">\
                <path d="M11.1488 5.95292L2.63902 15.0502C2.27941 15.4346 2.27941 16.032 2.63902 16.4164L11.1488 25.5137" />\
            </g>\
            <g filter="url(#filter1_i_957_5366_fl_' + $(this).data('uid') + ')">\
                <path d="M20.2969 30.6168L20.2969 15.3084L20.2969 0" />\
            </g>\
            <defs>\
                <filter id="filter0_i_957_5366_fl_' + $(this).data('uid') + '" x="0.869141" y="4.92822" width="11.375" height="22.6102" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>\
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>\
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\
                    <feOffset dy="1"/>\
                    <feGaussianBlur stdDeviation="0.5"/>\
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>\
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>\
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_957_5366"/>\
                </filter>\
                <filter id="filter1_i_957_5366_fl_' + $(this).data('uid') + '" x="18.7969" y="0" width="3" height="31.6168" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>\
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>\
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\
                    <feOffset dy="1"/>\
                    <feGaussianBlur stdDeviation="0.5"/>\
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>\
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>\
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_957_5366"/>\
                </filter>\
            </defs>\
          </svg>';
          $(this).prepend('<a class="menu-desktop-current-page__next-lvl__go-back">' + svg_back + '</a>');
        });
        

        firstLevelMobile.show();

        hamburger.on('click', function(){
            hamburger.hide();
            language.hide();
            closeMenuMobile.show().css('display', 'flex');
            languageSelect.hide();

            /* show always first level */

            if(menuMobileContainer.hasClass('animate__slideOutLeft')) {
                menuMobileContainer.removeClass('animate__slideOutLeft').addClass('animate__slideInLeft').show();
                $('body').css('overflow', 'hidden');
            } else {
                menuMobileContainer.addClass('animate__slideInLeft').show();
                $('body').css('overflow', 'hidden');
                console.log(menuLinkArrow.length);
                if (menuLinkArrow.length <= 0) {
                    menuLink.each(function() {
                      if($(this).next().length) {
                        $(this).append('<span class="menu-link-arrow">' + svg_next + '</span>');
                      }
                    });
                }
            }
        });


        /* close menu mobile */
        closeMenuMobile.on('click', function(e){

          $('.menu-desktop-links__item__link.opened').closest('.menu-desktop-links__item').find('.menu-desktop-current-page__next-lvl__go-back').trigger('click');

          $(navLink).each(function(index){
            if($(this).hasClass('opened')) {
              dropDownOut($(this).next());
            }
          });

          e.preventDefault();
          closeMenuMobile.hide();
          hamburger.show();
          language.show();
          menuMobileContainer.removeClass('animate__slideInLeft').addClass('animate__slideOutLeft');
          $('body').css('overflow', 'unset');
        });
    }

    var header = $('header');
    /* header height */
    function headerHeight() {
        let headerHeight = header.innerHeight();
        return headerHeight;
    }

    var treshold = 0;
    var lastScroll = 0;
    /* fixed on top header */
    function stickyHeader() {
        let headerH = headerHeight();
        let main = $('main');
        main.css('padding-top', headerH);

        var newScroll = $(document).scrollTop(),
        diff = newScroll-lastScroll;

        let halfScroll = headerH - ((headerH / 100) * 50);

        let newHeaderH = headerH + halfScroll;
        // normalize treshold range
        if (newScroll > newHeaderH) {
            treshold = (treshold + diff > headerH) ? headerH : treshold + diff;
            treshold = (treshold < 0) ? 0 : treshold;
        } else if (newScroll == 0) {
            treshold = 0;
        }

        header.css('top', (-treshold)+'px');

        lastScroll = newScroll;
    }

    function menuDesktopHeight() {
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const menuDesktop = $('.menu-inner-desktop');
        const navbar = $('nav.navbar');
        const navbarHeight = navbar.outerHeight();
        const offsetTop = navbar.offset().top + navbarHeight;
        const menuTopPosition = offsetTop - $(window).scrollTop();
        const menuHeight = vh - menuTopPosition;
        menuDesktop.css('height', menuHeight).css('top', navbarHeight - navbar.css('padding-top'));
    }

    function switchMenuDesktopMobile() {
      var bp = bsBreakpoints.detectBreakpoint();
      if(!(bp == 'xl') && !(bp == 'xxl')) {
        menuMobileContainer.not('.menu-mobile').addClass('menu-mobile');
        menuMobileContainer.not('.animate__animated').addClass('animate__animated');
        firstLevelMobile.css('display', 'block');
      } else {
        menuMobileContainer.removeClass('menu-mobile').removeClass('animate__animated').removeClass('animate__slideInLeft');
        firstLevelMobile.css('display', 'flex');
      }
    }

    /* slider block function */
    function sliderImg() {
        var swiper = new Swiper(".mySwiper", {
            loop: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
        });
    }


    /* arrows buttons - rotation function */
    function rotateArrow() {
      $("*[class*='rotate-arrow-base']").not('.breadcrumb-item-arrow').on('click', function(e){
        $(this).toggleClass('rotate-arrow-base');
      });
    }


    /* open list on click function */
    function openListOnClick() {
      let clickOpenList = $('.click-open-list');
      clickOpenList.on('click', function(e) {
        e.preventDefault();
        let targetList = $(this).parents('.click-open-list-container').find('.click-open-list-target');
        targetList.slideToggle(500);
      });
    }


    function breadcrumbHover() {
      /* generic breadcrumb */
      let linkBreadcrumbs = $('.breadcrumb-container > .breadcrumb > .breadcrumb-item > .breadcrumb-item-link');
      linkBreadcrumbs.hoverIntent({
        sensitivity: 6,
        interval: 100,
        timeout: 50,
        over: function() {
          $(this).children('.breadcrumb-item-arrow').toggleClass('rotate-arrow-base');
          $(this).children('.breadcrumb-item-dropdown').slideDown().show();
        },
        out: function() {
          $(this).children('.breadcrumb-item-arrow').toggleClass('rotate-arrow-base');
          $(this).children('.breadcrumb-item-dropdown').slideUp('fast');
        }
      });
    }

    function cubeHover() {
      let cubes = $('.mixed-cubes .default-cubes.intern-hover');
      cubes.hoverIntent(function() {
        $(this).children('.cube-hover').toggleClass('active');
      });
    }


    function modalAutoShow() {
/*
      let cookiename = $('#autoModal').attr('data-cookie');

      if($.cookie(cookiename) != 'hide-' + cookiename) {
        $('#autoModal').modal('show');
      }

      $('.btn-setcookie').on('click', function() {
        let cookiename = $(this).parents('#autoModal').attr('data-cookie');
        $('#autoModal').modal('hide');
        let time = parseInt($(this).attr('data-time'));
        console.log(time);
        $.cookie(cookiename, 'hide-' + cookiename, { expires: time });
      });
*/
    }

  
    var maxHeight = function(elems){
        console.log(elems);
        return Math.max.apply(null, elems.map(function ()
        {
            return $(this).outerHeight();
        }).get());
    }

    function setEqualHeight(elSelector) {
      /* console.log(elSelector); */
      let elCount = $(elSelector).length;
      if(elCount < 2) {
        return;
      }
      let numRows = Math.floor(elCount /2);

      for(let i = 0; i < numRows; i++) {
        var iEl1 = (i*2) + 0;
        var iEl2 = iEl1 + 1;
        /* console.log(iEl1, iEl2); */

        let height = Math.max($($(elSelector)[iEl1]).outerHeight(), $($(elSelector)[iEl2]).outerHeight());
        /* console.log(height); */
        $($(elSelector)[iEl1]).css('minHeight', height);
        $($(elSelector)[iEl2]).css('minHeight', height);
      }
    }

    function resetEqualHeight() {
      let classNameStart = 'equal-height-';
      /* reset */
      $("*[class^='" + classNameStart + "'], *[class*=' " + classNameStart + "']").css('minHeight', '');
      $("*[class^='" + classNameStart + "'], *[class*=' " + classNameStart + "']").css('minHeight', '');
    }

    function fastlinkContentHeight() {
        /* add classes to equalize height */
        $('.fast-links-list-article__title, .fast-links-list-article__content').not('equal-height-xl').addClass('equal-height-xl');
        $('.fast-links-list-article__title, .fast-links-list-article__content').not('equal-height-xxl').addClass('equal-height-xxl');

        var bp = bsBreakpoints.detectBreakpoint();
        let className = 'equal-height-' + bp;

        setEqualHeight(".fast-links-list-article__title." + className);
        setEqualHeight(".fast-links-list-article__content." + className);
    }

    
    function newsAndPressReleaseHeight() {
      /* add classes to equalize height */
      $('.press-col__title, .press-col__date, .press-col__image').not('equal-height-lg').addClass('equal-height-lg');
      $('.press-col__title, .press-col__date, .press-col__image').not('equal-height-xl').addClass('equal-height-xl');
      $('.press-col__title, .press-col__date, .press-col__image').not('equal-height-xxl').addClass('equal-height-xxl');

      var bp = bsBreakpoints.detectBreakpoint();
      let className = 'equal-height-' + bp;

      setEqualHeight(".press-col__title." + className);
      setEqualHeight(".press-col__date." + className);
      setEqualHeight(".press-col__image." + className);
    }

    function stopVideoOnCloseModal() {
      $('.modal.fade.modal-custom').on('hidden.bs.modal', function (e) {
        if($('iframe', this).length) {
          $('iframe', this).attr('src', $('iframe', this).attr('src'));
        }
      });
    }

    /* back to top button */
    var backToTop = $('#back-to-top');
    /* set function menu sticky */
    function backToTopButton() {
      var scrollTop = $(window).scrollTop();
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      if (scrollTop > vh) {
        // $('#site_header').addClass('site-header-bg');
        backToTop.fadeIn();
        backToTop.css('display', 'flex');
      } else if (scrollTop <= vh) {
        // $('#site_header').removeClass('site-header-bg');
        backToTop.fadeOut();
      }
    }

    /* set function back to top */
    backToTop.on('click', function(e) {
        (e).preventDefault();
      $("html, body").animate({ scrollTop: 0 });
      return false;
    });


    /* set function hotspot */
    function hotspot(componentDetails) {
      let ansaldoWrapperBorder = $('#hotspot-section > .hotspot__border');
      let hotspot = $('#hotspot-section > .hotspot__border > .hotspot__border__wrapper > .hotspot__border__wrapper__image > .hotspot__border__wrapper__image__spot');
      let hotspotTitle = $('#hotspot-section > .hotspot__title > .hotspot__title__text');
      let hotspotImg = $('#hotspot-section > .hotspot__border > .hotspot__border__wrapper > .hotspot__border__wrapper__image > img');
      let hotspotDescription = $('#hotspot-section > .hotspot__border > .hotspot__border__description');
      var hotspotDescriptionTitle = $('#hotspot-section > .hotspot__border > .hotspot__border__description > .hotspot__border__description__title');
      let hotspotDescriptionList = $('#hotspot-section > .hotspot__border > .hotspot__border__description > .hotspot__border__description__list');
      let clickHere = $('#hotspot-click-here');
      let hotspotClose = $('#hotspot-close');
      let fade = 400;
      var detailsArray = componentDetails;
      // let componentName = detailsArray.turbineName;
      let componentSpot1 = detailsArray.spot1;
      let componentSpot2 = detailsArray.spot2;
      let hotspotArray = detailsArray.hotspotsPositions;
      // let componentClass = 'hotspot-'+componentName;

      /* adding the title to the section */
      hotspotTitle.text(detailsArray.hotspotTitle);

      /* adding the first image of the turbine */
      hotspotImg.attr('src', componentSpot1);

      /* hotspot first step */
      clickHere.on('click', function(){
        $(this).fadeOut(fade).removeClass('active');
        hotspotImg.fadeOut(fade, function(){
          $(this).attr('src', componentSpot2);
        }).fadeIn(fade);
        setTimeout(function(){
          hotspotClose.fadeIn(fade).addClass('active');
          hotspot.fadeIn(600).addClass('active').css('display', ('flex'));
        }, 500); 
        
        /* looping through the DOM buttons element to pair them to the positions of the array */
        $.each(hotspot, function(index){  
          index++;
          let thisHotspotValue = $(this).val();
          if(thisHotspotValue == index) {
            let hotspPositionsRightObject = hotspotArray['hotspot'+thisHotspotValue];
            $(this).css('left', hotspPositionsRightObject.left).css('top', hotspPositionsRightObject.top);
          }
        }) 
      });

      /* goes back to first step */ 
      hotspotClose.on('click', function(){
        hotspot.fadeOut().removeClass('btn--hotspot--clicked').removeClass('active');
        // hotspot.fadeOut(fade).removeClass('active');
        hotspotClose.fadeOut(fade).removeClass('active');
        hotspotImg.fadeOut(fade, function(){
          $(this).attr('src', componentSpot1);
        }).fadeIn(fade);
        setTimeout(function(){
          clickHere.fadeIn(fade).addClass('active');
        }, 500); 
        hotspotDescription.slideDown().addClass('active');
        hotspotDescription.slideUp().removeClass('active');
        ansaldoWrapperBorder.removeClass('border');
        setTimeout(function(){
          hotspotDescriptionList.empty();
          hotspotDescriptionTitle.empty();
        }, 400); 
      });

      /* hotspot numbers showing details and infos */
      hotspot.on('click', function(){
        const hotspotValue = $(this).val();
        const correctImg =  'spot3hotspot'+hotspotValue;
        const correctList = 'list'+hotspotValue;
        const correctTitle = 'title'+hotspotValue;

        /* setting the hotspot opacity on the hotspot clicked */
        if(hotspot.hasClass('btn--hotspot--clicked') && $(this).not('btn--hotspot--clicked')) {
          hotspot.removeClass('btn--hotspot--clicked');
          $(this).addClass('btn--hotspot--clicked');
        } else {
          $(this).addClass('btn--hotspot--clicked');
        }  

        /* hotspot details text switch and animations */
        if(hotspotDescription.hasClass('active')) {
          
          hotspotDescription.slideUp().removeClass('active');
          setTimeout(function(){
            hotspotDescriptionList.empty();
            hotspotDescriptionTitle.empty();
            showText(correctTitle, correctList, hotspotDescriptionTitle, detailsArray, hotspotDescriptionList);
          }, 400); 

          setTimeout(function(){
            hotspotDescriptionList.empty();
            hotspotDescriptionTitle.empty();
            showText(correctTitle, correctList, hotspotDescriptionTitle, detailsArray, hotspotDescriptionList);
            hotspotDescription.slideDown().addClass('active');
          }, 450);           
          
        } else {
          showText(correctTitle, correctList, hotspotDescriptionTitle, detailsArray, hotspotDescriptionList)
          hotspotDescription.slideDown('slow').addClass('active');
          ansaldoWrapperBorder.addClass('border');
        } 
        
        /* hotspotImg.fadeOut(fade, function(){
          $(this).attr('src', correctImg);
        }).fadeIn(fade); */

        /* fetching the correct image which matches to the right hotspot */
        hotspotImg.attr('src', detailsArray[correctImg]);

      });
    }

    /* set function show text in component */
    function showText(title, list, divTitle, array, divList) {
      if(title in array) {
        divTitle.text(array[title]);
      }
      $.each(array[list], function(i, value){
        divList.append('<li class="hotspot__border__description__list__item"><p>'+value+'</p></li>');
      }); 
    }

    /* set function energy saver*/
    function energySaverInit() {
      if(!$('#energy-saver').length) {
        return;
      }
      let energySaver = $('.energy-saver').first();
      let moveTimer;
      let energySaverTime = 1000; //to count down every 1 second
      let time;
      let timeSet = 150; //2 mins 30 sec -> 150
    

      clearInterval(moveTimer);
      time = timeSet;
      moveTimer = setInterval(function(){
          loop()
      } ,energySaverTime)

      $(document).on('mouseleave mousemove', function(){
        if (energySaver.is(':not(:visible)')) {
          resetEnergySaver();
        }
      });

      $(document).on('click swipe tap keydown scroll', function(){
        energySaver.fadeOut(400).removeClass('active');
        resetEnergySaver();
      });

      function resetEnergySaver() {
        clearInterval(moveTimer);
        time = timeSet;
        moveTimer = setInterval(function(){
            loop()
        } ,energySaverTime)
      }

      function loop(){
        time--;
        if (time <=0 ) {
          clearInterval(moveTimer); 
          energySaver.fadeIn(400).addClass('active');
        }
      }
    }
    


    $(window).on('resize', function() {
        switchMenuDesktopMobile();
        backToTopButton();
        sliderImg();
        headerHeight();
        stickyHeader();
        menuDesktopHeight();
        resetEqualHeight();
        fastlinkContentHeight();
        newsAndPressReleaseHeight();
    });

    $(window).scroll(function() {
        backToTopButton();
        stickyHeader();
    });

    jQuery(document).ready(() => {
      bsBreakpoints.init();
      switchMenuDesktopMobile();
      menuDesktop();
      menuMobile();
      backToTopButton();
      sliderImg();
      rotateArrow();
      breadcrumbHover();
      headerHeight();
      stickyHeader();
      energySaverInit(); 

      fastlinkContentHeight();
      newsAndPressReleaseHeight();
      cubeHover();
      openListOnClick();
      stopVideoOnCloseModal();
      modalAutoShow();

      if($('#hotspot-section').length && (typeof hotspotVars == 'object') ) {
        hotspot(hotspotVars);
      } else if ($('#hotspot-section').length && (typeof hotspotVars != 'object') ){
        console.log('error: initialized const does not exist');
      }

    });

})(jQuery);
